import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import format from 'date-fns/format';

import { formatPriceForDisplay } from '../../../../../../../../../util/format-money';

const propTypes = {
  className: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const LimitedTimeOfferCta = ({ className, albumFolder }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <span className={classes}>
      Only ${formatPriceForDisplay(albumFolder.limited_time_offer_price.value)}{' '}
      if you buy before{' '}
      <span className="text-extra-bold">
        {format(new Date(albumFolder.limited_time_offer_date_end), 'MMMM Mo')}
      </span>
      .
    </span>
  );
};

LimitedTimeOfferCta.propTypes = propTypes;

export default LimitedTimeOfferCta;
